import React, { useState } from 'react';
import { Row, Col, Popup, Button } from '@commonsku/styles';
import Form from './form/CompanyCommissionClientRate';
import useCompanyCommissionClientRates from './hooks/useCompanyCommissionClientRates';
import TopInfo from './misc/Info';
import ReactTooltip from 'react-tooltip';
import AdminCommissionAssignClientRate from './AdminCommissionAssignClientRate';

export default function AdminCommissionClientRate() {
    const [items, , save, remove] = useCompanyCommissionClientRates();
    const [openClient, setOpenClient] = useState(false);
    let popup = null;
    if (openClient) {
        popup = (
            <Popup
                style={{ padding: 20, maxWidth: '1600px', zIndex: 10001 }}
                width='calc(100vw - 100px)'
                height='calc(100vh - 100px)'
                header={
                    <Row className='popup-header' justify="space-between" wrap="nowrap" style={{ alignItems: 'flex-start' }}>
                        <h2 style={{ margin: '0.2em' }}>Client Rate</h2>
                        <div>
                            <Button onClick={() => setOpenClient(false)}>Done</Button>
                        </div>
                    </Row>
                }>
                <AdminCommissionAssignClientRate />
            </Popup>
        );
    }

    const list = items.map((item, index) => {
        return (
            <Row key={item.commission_client_rate_id}>
                <Form item={item} saveItem={save} deleteItem={remove} />
            </Row>
        );
    });

    const add = (
        <Row>
            <Form saveItem={save} />
        </Row>
    );

    const assignButton = (
        <Button size='small' onClick={() => {
            setOpenClient(true);
        }} key='people-button'>Assign Client Rates</Button>
    );

    return (
        <>
            <TopInfo message={'Increase or decrease your team\'s commissions by applying a multiplier to their commission based on the client.'} link='https://help.commonsku.com/knowledge/how-to-create-update-commissions#client-rates' buttons={[assignButton]} />
            <Row>
                <Col padded sm={8}>
                    <b>Label</b>
                </Col>
                <Col padded sm={3}>
                    <b>Multiplier</b>
                </Col>
                <Col padded sm={1}>
                </Col>
            </Row>
            {list}
            {add}
            <ReactTooltip />
            {popup}
        </>
    );
}
